import { Edit as ComposeIcon, Inbox as InboxIcon, Send as SentIcon, Computer as SystemIcon } from '@mui/icons-material';
import { ELinks } from '@sharedInterfaces/globalEnums';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import InnerLayout from '@src/App/Components/Core/Layouts/InnerLayout/InnerLayout';
import type { ITabConfig } from '@src/App/Components/Core/Layouts/LayoutElements/MvpTabContainer/ITabConfig';
import { useNavigation } from '@src/App/Components/Core/Navigation/NavigationContext';
import type { AppState } from '@store/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ComposeTab } from './tabs/ComposeTab';
import { InboxTab } from './tabs/InboxTab';
import { SentTab } from './tabs/SentTab';
import { SystemTab } from './tabs/SystemTab';

export enum EMessageTabs {
    INBOX = 0,
    SENT = 1,
    SYSTEM = 2,
    COMPOSE = 3,
}

interface MessagesPageProps {
    tabId: EMessageTabs;
}

export function MessagesPage({ tabId }: MessagesPageProps) {
    const { setSubNav } = useNavigation();
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).navigation;

    const messageTabs = [
        {
            icon: <InboxIcon />,
            label: 'Posteingang',
            url: `/${ELinks.MESSAGES}`,
            key: EMessageTabs.INBOX,
            render: <InboxTab />,
        },
        {
            icon: <SentIcon />,
            label: 'Gesendet',
            url: `/${ELinks.MESSAGES}/sent`,
            key: EMessageTabs.SENT,
            render: <SentTab />,
        },
        {
            icon: <SystemIcon />,
            label: 'System',
            url: `/${ELinks.MESSAGES}/system`,
            key: EMessageTabs.SYSTEM,
            render: <SystemTab />,
        },
        {
            icon: <ComposeIcon />,
            label: 'Verfassen',
            url: `/${ELinks.MESSAGES}/compose`,
            key: EMessageTabs.COMPOSE,
            render: <ComposeTab />,
        },
    ];

    useEffect(() => {
        const subNavTabs: ITabConfig[] = messageTabs.map((tab) => ({
            title: tab.label,
            link: tab.url,
            icon: React.cloneElement(tab.icon, { color: 'primary' }),
        }));

        setSubNav({ tabs: subNavTabs });

        return () => setSubNav(null);
    }, [setSubNav]);

    const activeTab = messageTabs.find((tab) => tab.key === tabId);

    return (
        <InnerLayout
            title={tabId === EMessageTabs.INBOX ? 'Nachrichten & Benachrichtigungen' : undefined}
            subTitle={
                tabId === EMessageTabs.INBOX
                    ? 'Verwalten Sie Ihre internen Nachrichten und System-Benachrichtigungen'
                    : undefined
            }
            showTabIcons={true}
        >
            {activeTab ? activeTab.render : <InboxTab />}
        </InnerLayout>
    );
}
